import { BrowserHistory } from 'history';
import {
    useCallback,
    useEffect,
    useLayoutEffect,
    useRef,
    useState,
} from 'react';
import { useSelector } from 'react-redux';
import { Router } from 'react-router-dom';

import {
    getAllowedRoutes,
    getNavigationIsBlocked,
} from 'features/NavigationBlockModal/model/selectors/navigationBlockSelectors';
import { useNavigationBlock } from 'features/NavigationBlockModal/ui/NavigationBlockProvider/NavigationBlockProvider';

type Props = {
    basename?: string;
    children: React.ReactNode;
    history: BrowserHistory;
};
export const CustomRouter = ({ basename, children, history }: Props) => {
    const ublockActionRef = useRef(() => {});
    const { validateNavBlock } = useNavigationBlock();
    const isBlocked = useSelector(getNavigationIsBlocked);
    const allowedRoutes = useSelector(getAllowedRoutes);

    const [state, setState] = useState({
        action: history.action,
        location: history.location,
    });

    useLayoutEffect(() => history.listen(setState), [history]);

    const onBlock = useCallback(() => {
        let unblock = history.block((tx) => {
            const isAllowedRoute = allowedRoutes.some((pattern: string) =>
                new RegExp(pattern).test(tx.location.pathname),
            );

            validateNavBlock(() => {
                unblock();
                tx.retry();
            }, !isAllowedRoute);
        });

        ublockActionRef.current = unblock;
    }, [history, validateNavBlock, allowedRoutes]);

    useEffect(() => {
        if (isBlocked) {
            onBlock();
        } else {
            ublockActionRef.current();
            validateNavBlock(() => {}, false);
            ublockActionRef.current = () => {};
        }
    }, [isBlocked, onBlock, validateNavBlock]);

    return (
        <Router
            basename={basename}
            location={state.location}
            navigator={history}
            navigationType={state.action}
        >
            {children}
        </Router>
    );
};
